export enum ETipoDeclarante {
  TITULAR_ARRENDATARIO = 0,
  PRIMEIRO_ADQUIRENTE = 1,
  HASTA_PUBLICA = 2,
}
